/**
 * EXAMPLE
 * <scroll-to data-options='{}'>
 *   <button>
 *     Label
 *   </button>
 * </scroll-to>
 */

if (!customElements.get('scroll-to')) {
  class ScrollTo extends HTMLElement {
    constructor() {
      super();

      // Options
      this.options = {
        target: "body",
        offset: 100
      }

      // Get options from element data and combine with this.options
      if (this?.dataset?.options) {
        const dataOptions = JSON.parse(this.dataset.options);
        this.options = {
          ...this.options,
          ...dataOptions
        };
      }

      this.target = document.querySelector(this.options.target);
      this.addEventListener('click', (e) => this.scrollTo());
    }

    /**
     * Get scroll to position
     */
    getScrollToPosition() {
      this.targetOffsetTop = this.target.offsetTop
      return this.target.offsetTop - this.options.offset
    }

    /**
     * Handle scroll event
     */
    scrollTo() {
      window.scrollTo(0, this.getScrollToPosition())
    }
  }

  window.ScrollTo = ScrollTo;
  customElements.define('scroll-to', ScrollTo);
}
